var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "hazopActionTab",
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    hcfFacilityType: tab.hcfFacilityType,
                    popupParam: _vm.popupParam,
                    facilityStatusTable: _vm.facilityStatusTable,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:hcfFacilityType": function ($event) {
                      return _vm.$set(tab, "hcfFacilityType", $event)
                    },
                    "update:hcf-facility-type": function ($event) {
                      return _vm.$set(tab, "hcfFacilityType", $event)
                    },
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }